import VolumeSlider from './VolumeSlider';
import SpeedSlider from './SpeedSlider';
import PitchSlider from './PitchSlider';
import Suggestions from './Suggestions'
import Sentence from './Sentence';
import TextsEditor from './TextsEditor';

export { VolumeSlider, PitchSlider, Sentence, SpeedSlider, Suggestions, TextsEditor };


// WEBPACK FOOTER //
// ./src/components/index.js